import AboutUs from "../../pages/AboutUs";
import Contact from "../../pages/contact";
import Home from "../../pages/Home";
import PrivacyPolicy from "../../pages/PrivacyPolicy";
import Services from "../../pages/Services";
import TermsCondition from "../../pages/TermsCondition";
import Location from "../../pages/location"

export const routes = [
    {
        path:"/",
        component:<Home/>,
        private:false,
        roles:[]
    },
    {
        path:"/home",
        component:<Home/>,
        private:false,
        roles:[]
    },
    {
        path:"/about",
        component:<AboutUs/>,
        private:true,
        roles:[]
    },
    {
        path:"/privacy_policy",
        component:<PrivacyPolicy/>,
        private:true,
        roles:[]
    },
    {
        path:"/services",
        component:<Services/>,
        private:true,
        roles:[]
    },
     {
        path:"/terms_and_condition",
        component:<TermsCondition/>,
        private:true,
        roles:[]
    },
    {
        path:"/contact_us",
        component:<Contact/>,
        private:true,
        roles:[]
    },
    {
        path:"/location",
        component:<Location />, 
        private:true,
        roles:[]
    },
    
]